import { Injectable } from '@angular/core';
import { DatiqTooltipTypes, IDatiqTooltip } from '../models';

@Injectable({
    providedIn: 'root',
})
export class DatiqTooltipMapperService {
    constructor() {}

    isInfo(settings: IDatiqTooltip): boolean {
        return settings?.type === DatiqTooltipTypes.Info;
    }
}
